import level_1 from "./1.json";
import level_2 from "./2.json";
import level_3 from "./3.json";
import { TPosition } from "../core/types";

export const levels = [level_1, level_2, level_3] as TPosition[][];
